import React from 'react';
import { useAlert, useAlertState } from '../contexts/alertContext'; 
import Alerting from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Icon from '@mdi/react';
import { mdiClose } from "@mdi/js";
import { AlertTitle } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import '../css/theme';
import '../css/global.css';

const Alert = () => {
  const { isAlertVisible, alertMessage, severity, openMenu } = useAlertState();
  const { hideAlert } = useAlert();
  const theme = useTheme();

  const getTitle = (severity) => {
    switch (severity) {
      case 'success':
        return {
          title: 'Success',
          backgroundColor: theme.palette.successalert.main 
        };
      case 'error':
        return {
          title: 'Error',
          backgroundColor: theme.palette.erroralert.main 
        };
      case 'warning':
        return {
          title: 'Warning',
        };
      default:
        return {
          title: 'Info',
        };
    }
  };

  const { title, backgroundColor } = getTitle(severity);

  return (
    <div style={{ overflowY: "visible" }}>
      <Collapse in={isAlertVisible}>
        <Alerting
          className='Alert'
          style={{ 
            width: (openMenu) ? "calc(100% - 250px)" : "calc(100% - 50%)", 
            paddingTop: "0px",
            paddingBottom: "0px",
            zIndex: theme.zIndex.tooltip, 
            color: 'white', 
            backgroundColor: backgroundColor 
          }}
          variant="filled"
          severity={severity}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {hideAlert()}} 
            >
              <Icon path={mdiClose} size="18px" />
            </IconButton>
          }
        >
          <AlertTitle>{title}</AlertTitle>
          {alertMessage}
        </Alerting>
      </Collapse>
    </div>
  );
};

export default React.memo(Alert);